import { Map, fromJS } from 'immutable';

import Actions from 'flow/actions';
import { listToMap } from 'flow/utils';

const initialState = Map();

const callRoutingReducer = (state = initialState, action) => {
    switch (action ? action.type : null) {
        case Actions.CLEAR_STATE: {
            return initialState;
        }
        case Actions.RESULT_CALL_ROUTINGS: {
            const callRoutings = fromJS(action.data);
            const callRoutingsMap = listToMap(callRoutings, (routing) =>
                routing.get('key'),
            );
            const blockedCalls = callRoutingsMap.filter(
                (routing) => routing.get('redirect') !== 'passthrough',
            );
            const priorityCalls = callRoutingsMap.filter(
                (routing) => routing.get('redirect') === 'passthrough',
            );
            const blockedIn = blockedCalls.filter((routing) =>
                routing.get('isIncoming'),
            );
            const blockedOut = blockedCalls.filter(
                (routing) => !routing.get('isIncoming'),
            );

            return state
                .set('blocked_in', blockedIn || Map())
                .set('blocked_out', blockedOut || Map())
                .set('priority', priorityCalls || Map());
        }
        case Actions.RESULT_CALL_ROUTINGS_DELETED: {
            const deletedKeysList = fromJS(action.data);
            // Use deleteAll() when introduced to stable immutable version
            const filterDeleted = (callRoutingMap) =>
                callRoutingMap.filterNot((_routing, routingKey) =>
                    deletedKeysList.includes(routingKey),
                );

            return state
                .update('blocked_in', filterDeleted)
                .update('blocked_out', filterDeleted)
                .update('priority', filterDeleted);
        }
        case Actions.RESULT_CALL_ROUTINGS_UPDATED: {
            const editedCallRoutings = fromJS(action.data);
            const editedCallRoutingsMap = listToMap(
                editedCallRoutings,
                (routing) => routing.get('key'),
            );
            const blockedCalls = editedCallRoutingsMap.filter(
                (routing) => routing.get('redirect') !== 'passthrough',
            );
            const priorityCalls = editedCallRoutingsMap.filter(
                (routing) => routing.get('redirect') === 'passthrough',
            );
            const blockedIn = blockedCalls.filter((routing) =>
                routing.get('isIncoming'),
            );
            const blockedOut = blockedCalls.filter(
                (routing) => !routing.get('isIncoming'),
            );

            return state
                .update('blocked_in', (callRoutingMap) =>
                    callRoutingMap.merge(blockedIn),
                )
                .update('blocked_out', (callRoutingMap) =>
                    callRoutingMap.merge(blockedOut),
                )
                .update('priority', (callRoutingMap) =>
                    callRoutingMap.merge(priorityCalls),
                );
        }
        case Actions.RESULT_CALL_ROUTINGS_PREDEFS: {
            const predefList = fromJS(action.data);

            const predefIn = predefList.filter((predef) =>
                predef.get('isIncoming'),
            );
            const predefOut = predefList.filter(
                (predef) => !predef.get('isIncoming'),
            );

            return state
                .set('predefList_in', predefIn)
                .set('predefList_out', predefOut);
        }
        case Actions.RESULT_DELETE_CALL_ROUTING: {
            return state;
        }
        default: {
            return state;
        }
    }
};

export default callRoutingReducer;
